/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectDomainAdditionalPaymentData
 */
export interface ProjectDomainAdditionalPaymentData {
    /**
     * 
     * @type {number}
     * @memberof ProjectDomainAdditionalPaymentData
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectDomainAdditionalPaymentData
     */
    fullPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectDomainAdditionalPaymentData
     */
    domainsToPay?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectDomainAdditionalPaymentData
     */
    totalExtraPaidDomains?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectDomainAdditionalPaymentData
     */
    isAdditionalPaymentNeeded?: boolean;
}

/**
 * Check if a given object implements the ProjectDomainAdditionalPaymentData interface.
 */
export function instanceOfProjectDomainAdditionalPaymentData(value: object): value is ProjectDomainAdditionalPaymentData {
    return true;
}

export function ProjectDomainAdditionalPaymentDataFromJSON(json: any): ProjectDomainAdditionalPaymentData {
    return ProjectDomainAdditionalPaymentDataFromJSONTyped(json, false);
}

export function ProjectDomainAdditionalPaymentDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectDomainAdditionalPaymentData {
    if (json == null) {
        return json;
    }
    return {
        
        'price': json['price'] == null ? undefined : json['price'],
        'fullPrice': json['fullPrice'] == null ? undefined : json['fullPrice'],
        'domainsToPay': json['domainsToPay'] == null ? undefined : json['domainsToPay'],
        'totalExtraPaidDomains': json['totalExtraPaidDomains'] == null ? undefined : json['totalExtraPaidDomains'],
        'isAdditionalPaymentNeeded': json['isAdditionalPaymentNeeded'] == null ? undefined : json['isAdditionalPaymentNeeded'],
    };
}

export function ProjectDomainAdditionalPaymentDataToJSON(json: any): ProjectDomainAdditionalPaymentData {
    return ProjectDomainAdditionalPaymentDataToJSONTyped(json, false);
}

export function ProjectDomainAdditionalPaymentDataToJSONTyped(value?: ProjectDomainAdditionalPaymentData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'price': value['price'],
        'fullPrice': value['fullPrice'],
        'domainsToPay': value['domainsToPay'],
        'totalExtraPaidDomains': value['totalExtraPaidDomains'],
        'isAdditionalPaymentNeeded': value['isAdditionalPaymentNeeded'],
    };
}

